import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';
import { ToTypeOrm } from '../models/_to-type-orm.schema';
import { RefundRequest } from '../models/refund-request.schema';

@Injectable({
  providedIn: 'root'
})
export class RefundRequestsService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/refund-requests`;

  async getAllRefundRequests(page?: number, limit?: number, order?: {}, filter: any = {}): Promise<any> {
    return this.getAll(page, limit, order, filter);
  }

  async getAll(page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<any>{
    let params = {};
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => this.http.get(`${this.url}`, { params: params }).toPromise() );
  }

  async createRefundRequest(formValues: any): Promise<any>{
    return this.request(() => this.http.post(`${this.url}`, formValues ).toPromise() );
  }

  async updateRefundRequest(id: number, formValues: any): Promise<any>{
    return this.request(() => this.http.put(`${this.url}/${id}`, formValues ).toPromise() );
  }

  async getRefundRequest(id: number): Promise<any>{
    return this.request(() => this.http.get(`${this.url}/${id}` ).toPromise() );
  }

  async deleteRefundRequest(id: number): Promise<any>{
    return this.request(() => this.http.delete(`${this.url}/${id}` ).toPromise() );
  }

  async approveSalaryRefund(id: number): Promise<RefundRequest> {
    return this.request(() => this.http.put(`${this.url}/approve/${id}`, {} ).toPromise() );
  }

  async paidSalaryRefund(id: number): Promise<RefundRequest> {
    return this.request(() => this.http.put(`${this.url}/paid/${id}`, {} ).toPromise() );
  }
}
